export const SCORING_THRESHOLDS = {
  management_control: {
    low: { min: 7, max: 9 },
    medium: { min: 9.1, max: 14 },
    high: { min: 14.1, max: 18 }
  },
  cold_water_outlets: {
    low: { min: 5, max: 7 },
    medium: { min: 7.1, max: 12 },
    high: { min: 12.1, max: 15 }
  },
  hot_water_outlets: {
    low: { min: 5, max: 7 },
    medium: { min: 7.1, max: 12 },
    high: { min: 12.1, max: 15 }
  },
  cold_water_storage_tanks: {
    low: { min: 7, max: 10 },
    medium: { min: 10.1, max: 15 },
    high: { min: 15.1, max: 21 }
  },
  hot_water_heaters: {
    low: { min: 5, max: 6 },
    medium: { min: 6.1, max: 9 },
    high: { min: 9.1, max: 12 }
  },
  point_of_use_heaters: {
    low: { min: 5, max: 6 },
    medium: { min: 6.1, max: 9 },
    high: { min: 9.1, max: 12 }
  }
}

export interface RiskScores {
  management_control: number
  cold_water_outlets: number
  hot_water_outlets: number
  cold_water_storage_tanks?: number
  hot_water_heaters?: number
  point_of_use_heaters?: number
  overall: number
}

export function calculateRiskRating(score: number, category: keyof typeof SCORING_THRESHOLDS): string {
  const thresholds = SCORING_THRESHOLDS[category]
  if (score >= thresholds.low.min && score <= thresholds.low.max) return 'Low'
  if (score >= thresholds.medium.min && score <= thresholds.medium.max) return 'Medium'
  if (score >= thresholds.high.min && score <= thresholds.high.max) return 'High'
  return 'Unknown'
}

export function calculateManagementControlScore(data: Record<string, number>): number {
  const fields = [
    'current_control_procedures',
    'management_structure',
    'susceptibility',
    'density_exposed',
    'pipework_material',
    'pipework_insulation'
  ]
  return fields.reduce((sum, field) => sum + (data[field] || 0), 0)
}

export function calculateOutletScore(data: Record<string, number>): number {
  const fields = [
    'formation_droplets',
    'water_condition',
    'temperature',
    'turnover',
    'control_procedures'
  ]
  return fields.reduce((sum, field) => sum + (data[field] || 0), 0)
}
